import { useEffect, useState } from 'react';
import { useLazyGetTripsByTripIdUrlQuery } from '../../store/backendApi';

/**
 * Platform-agnostic hook for fetching and managing trip URL for a favorite trip.
 * Handles lazy loading of trip URL from API.
 */
export function useFavoriteTripUrl(tripId: string) {
  const [fetchTripUrl] = useLazyGetTripsByTripIdUrlQuery();
  const [tripUrl, setTripUrl] = useState<string | null>(null);
  const [isLoadingUrl, setIsLoadingUrl] = useState(true);

  useEffect(() => {
    const loadUrl = async () => {
      try {
        const result = await fetchTripUrl(tripId).unwrap();
        setTripUrl(result.url ?? null);
      } catch (error) {
        setTripUrl(null);
      } finally {
        setIsLoadingUrl(false);
      }
    };
    loadUrl();
  }, [tripId, fetchTripUrl]);

  return {
    tripUrl,
    isLoadingUrl,
  };
}
